import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Thumb } from "@/components/ds";
import { fileUrl, gramas } from "@/lib/api";
import { cn } from "@/lib/utils";

/** Componente reutilizável de seleção de filamento do estoque (Plate, Produção, etc). */
export function FilamentPicker({ filaments, selectedId, onSelect, testid = "filament-picker" }) {
  const [q, setQ] = useState("");
  const term = q.trim().toLowerCase();
  const list = filaments.filter((f) =>
    [f.color_name, f.brand, f.material, f.manufacturer_color]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(term)
  );

  return (
    <div className="flex flex-col gap-3" data-testid={testid}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar por cor, marca ou material"
          className="pl-9"
          data-testid={`${testid}-search`}
        />
      </div>

      <div className="max-h-72 space-y-2 overflow-y-auto pr-1">
        {list.length === 0 && (
          <p className="py-6 text-center text-sm text-muted-foreground" data-testid={`${testid}-empty`}>
            Nenhum filamento encontrado no estoque.
          </p>
        )}
        {list.map((f) => (
          <button
            key={f.id}
            type="button"
            onClick={() => onSelect(f)}
            data-testid={`${testid}-option-${f.id}`}
            className={cn(
              "flex w-full items-center gap-3 rounded-lg border p-3 text-left transition-colors",
              selectedId === f.id
                ? "border-primary bg-primary/10"
                : "border-white/10 bg-secondary/40 hover:border-primary/40"
            )}
          >
            <Thumb src={fileUrl(f.photo_path)} alt={f.color_name} fallback={f.material?.slice(0, 3)} />
            <div className="min-w-0 flex-1">
              <p className="truncate font-medium">
                {f.material} {f.color_name}
              </p>
              <p className="truncate text-xs text-muted-foreground">{f.brand}</p>
            </div>
            <span
              className={cn(
                "font-num text-sm shrink-0",
                f.low_stock ? "text-red-300" : "text-emerald-300"
              )}
            >
              {gramas(f.balance_g)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
